/**
 * @generated SignedSource<<8461b8b031cf951b7f401b821460fcad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
export type TaskExecutionTextSaveTextMutation$variables = {
  employeeId?: string | null;
  id: string;
  value: string;
};
export type TaskExecutionTextSaveTextMutation$data = {
  readonly setTaskExecutionText: {
    readonly id: string;
    readonly isCompleted: boolean;
    readonly routineOccasion: {
      readonly id: string;
      readonly status: RoutineOccasionStatus;
    };
    readonly textValue: string | null;
  };
};
export type TaskExecutionTextSaveTextMutation = {
  response: TaskExecutionTextSaveTextMutation$data;
  variables: TaskExecutionTextSaveTextMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "employeeId",
        "variableName": "employeeId"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "TaskExecutionText",
    "kind": "LinkedField",
    "name": "setTaskExecutionText",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCompleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RoutineOccasion",
        "kind": "LinkedField",
        "name": "routineOccasion",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskExecutionTextSaveTextMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TaskExecutionTextSaveTextMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "cf22b83f75724eeb8cc5d59141a0e187",
    "id": null,
    "metadata": {},
    "name": "TaskExecutionTextSaveTextMutation",
    "operationKind": "mutation",
    "text": "mutation TaskExecutionTextSaveTextMutation(\n  $id: ID!\n  $value: String!\n  $employeeId: ID\n) {\n  setTaskExecutionText(id: $id, value: $value, employeeId: $employeeId) {\n    id\n    textValue\n    isCompleted\n    routineOccasion {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "39f7c74de7a620dbbfbe86b31ecc93dd";

export default node;
